const initVehicleFilter = {
  init: function () {
    this.initializeDropdowns();
    this.initializeEventListeners();
  },

  initializeDropdowns: function () {
    const vehicles = this.getVehicles();

    // Initialize all make dropdowns
    document.querySelectorAll(".makeDropdown").forEach((makeDropdown) => {
      makeDropdown.innerHTML = "";
      Object.keys(vehicles).forEach((marka) => {
        const li = document.createElement("li");
        li.textContent = marka;
        li.classList.add("vehicle-toggle");
        makeDropdown.appendChild(li);
      });
    });
  },

  initializeEventListeners: function () {
    // Use event delegation to avoid listener duplication issues
    if (!document.body.hasAttribute("data-vehicle-filter-initialized")) {
      // Dropdown toggle event delegation
      document.body.addEventListener("click", (e) => {
        if (
          e.target.closest(".filter-list-item") &&
          !e.target.closest(".dropdown")
        ) {
          this.handleDropdownToggle(e);
        }
      });

      // Vehicle selection event delegation
      document.body.addEventListener("click", (e) => {
        if (e.target.classList.contains("vehicle-toggle")) {
          this.handleVehicleSelection(e);
        }
      });

      // Search button event delegation
      document.body.addEventListener("click", (e) => {
        if (e.target.classList.contains("vehicle-search-btn")) {
          this.handleSearchClick(e);
        }
      });

      // Document click to close dropdowns
      document.body.addEventListener("click", (e) => {
        if (!e.target.closest(".filter-list")) {
          document.querySelectorAll(".dropdown").forEach((dropdown) => {
            dropdown.style.display = "none";
          });
        }
      });

      document.body.setAttribute("data-vehicle-filter-initialized", "true");
    }
  },

  handleDropdownToggle: function (event) {
    event.stopPropagation();

    const filterItem = event.target.closest(".filter-list-item");
    if (filterItem.classList.contains("disabled")) {
      return;
    }

    const clickedDropdown = filterItem.querySelector(".dropdown");

    // Close all other dropdowns
    document.querySelectorAll(".dropdown").forEach((dropdown) => {
      if (dropdown !== clickedDropdown) {
        dropdown.style.display = "none";
      }
    });

    // Toggle clicked dropdown
    if (clickedDropdown) {
      clickedDropdown.style.display =
        clickedDropdown.style.display === "block" ? "none" : "block";
    }
  },

  handleVehicleSelection: function (event) {
    event.stopPropagation();

    const parentDropdown = event.target.closest(".dropdown");
    const parentForm = event.target.closest(".vehicle-filter-form");

    if (parentDropdown.classList.contains("makeDropdown")) {
      const selectedMake = event.target.textContent;
      parentForm.querySelector(".makeSelectedCustom").textContent =
        selectedMake;
      parentForm.querySelector(".model-parent").classList.remove("disabled");
      parentForm.querySelector(".modelSelectedCustom").textContent =
        parentForm
          .querySelector(".modelSelectedCustom")
          .getAttribute("data-default") || "Model";
      this.updateModelDropdown(selectedMake, parentForm);

      // Reset and disable subsequent dropdowns
      parentForm.querySelector(".year-parent").classList.add("disabled");
      parentForm.querySelector(".generation-parent").classList.add("disabled");
      parentForm.querySelector(".yearSelectedCustom").textContent =
        parentForm
          .querySelector(".yearSelectedCustom")
          .getAttribute("data-default") || "Yıl";
      parentForm.querySelector(".generationSelectedCustom").textContent =
        parentForm
          .querySelector(".generationSelectedCustom")
          .getAttribute("data-default") || "Nesil/Kasa";
    } else if (parentDropdown.classList.contains("modelDropdown")) {
      const selectedModel = event.target.textContent;
      const selectedMake = parentForm.querySelector(
        ".makeSelectedCustom"
      ).textContent;
      parentForm.querySelector(".modelSelectedCustom").textContent =
        selectedModel;
      parentForm.querySelector(".year-parent").classList.remove("disabled");
      parentForm.querySelector(".yearSelectedCustom").textContent =
        parentForm
          .querySelector(".yearSelectedCustom")
          .getAttribute("data-default") || "Yıl";
      this.updateYearDropdown(selectedMake, selectedModel, parentForm);

      // Reset and disable subsequent dropdown
      parentForm.querySelector(".generation-parent").classList.add("disabled");
      parentForm.querySelector(".generationSelectedCustom").textContent =
        parentForm
          .querySelector(".generationSelectedCustom")
          .getAttribute("data-default") || "Nesil/Kasa";
    } else if (parentDropdown.classList.contains("yearDropdown")) {
      const selectedYear = event.target.textContent;
      const selectedMake = parentForm.querySelector(
        ".makeSelectedCustom"
      ).textContent;
      const selectedModel = parentForm.querySelector(
        ".modelSelectedCustom"
      ).textContent;
      parentForm.querySelector(".yearSelectedCustom").textContent =
        selectedYear;
      parentForm
        .querySelector(".generation-parent")
        .classList.remove("disabled");
      parentForm.querySelector(".generationSelectedCustom").textContent =
        parentForm
          .querySelector(".generationSelectedCustom")
          .getAttribute("data-default") || "Nesil/Kasa";
      this.updateGenerationDropdown(
        selectedMake,
        selectedModel,
        selectedYear,
        parentForm
      );
    } else if (parentDropdown.classList.contains("generationDropdown")) {
      parentForm.querySelector(".generationSelectedCustom").textContent =
        event.target.textContent;
    }

    // Close the dropdown after selection
    parentDropdown.style.display = "none";
  },

  handleSearchClick: function (event) {
    const parentForm = event.target.closest(".vehicle-filter-form");
    this.searchVehicleCustom(parentForm);
  },

  updateModelDropdown: function (selectedMake, parentForm) {
    const modelDropdown = parentForm.querySelector(".modelDropdown");
    if (modelDropdown) {
      modelDropdown.innerHTML = "";

      const vehicles = this.getVehicles();
      if (vehicles[selectedMake]) {
        const models = Object.keys(vehicles[selectedMake]);
        models.forEach((model) => {
          const li = document.createElement("li");
          li.textContent = model;
          li.classList.add("vehicle-toggle");
          modelDropdown.appendChild(li);
        });
      }
    }
  },

  updateYearDropdown: function (selectedMake, selectedModel, parentForm) {
    const yearDropdown = parentForm.querySelector(".yearDropdown");
    if (yearDropdown) {
      yearDropdown.innerHTML = "";

      const years = this.getYears();
      years.forEach((year) => {
        const li = document.createElement("li");
        li.textContent = year;
        li.classList.add("vehicle-toggle");
        yearDropdown.appendChild(li);
      });
    }
  },

  updateGenerationDropdown: function (
    selectedMake,
    selectedModel,
    selectedYear,
    parentForm
  ) {
    const generationDropdown = parentForm.querySelector(".generationDropdown");
    if (generationDropdown) {
      generationDropdown.innerHTML = "";

      const vehicles = this.getVehicles();
      if (vehicles[selectedMake] && vehicles[selectedMake][selectedModel]) {
        const vehicle = vehicles[selectedMake][selectedModel];
        if (Array.isArray(vehicle)) {
          vehicle.forEach((generation) => {
            const li = document.createElement("li");
            li.textContent = generation;
            li.classList.add("vehicle-toggle");
            generationDropdown.appendChild(li);
          });
        } else {
          const kasaTipi = vehicle.kasaTipi;
          const li = document.createElement("li");
          li.textContent = kasaTipi;
          li.classList.add("vehicle-toggle");
          generationDropdown.appendChild(li);
        }
      }
    }
  },

  searchVehicleCustom: function (parentForm) {
    const year = parentForm.querySelector(".yearSelectedCustom").textContent;
    const make = parentForm.querySelector(".makeSelectedCustom").textContent;
    const model = parentForm.querySelector(".modelSelectedCustom").textContent;
    const generation = parentForm.querySelector(
      ".generationSelectedCustom"
    ).textContent;

    // Check for default values (not selected)
    const defaultValues = [
      "Yıl",
      "Year",
      "Marka",
      "Make",
      "Model",
      "Nesil/Kasa",
      "Generation/Body",
    ];
    if (
      defaultValues.includes(year) ||
      defaultValues.includes(make) ||
      defaultValues.includes(model) ||
      defaultValues.includes(generation)
    ) {
      console.log("Not all fields selected");
      return;
    }

    const filterList = parentForm.querySelector(".filter-list");
    const shopBtn = parentForm.querySelector(".vehicle-search-btn");
    shopBtn.style.display = "none";
    filterList.style.display = "none";

    const loadingDiv = document.createElement("div");
    loadingDiv.classList.add("loading-div");
    loadingDiv.innerHTML = "Aranıyor...";
    filterList.parentNode.insertBefore(loadingDiv, filterList);

    // Remove any existing loading divs
    const existingLoadingDivs = document.querySelectorAll(".loading-div");
    existingLoadingDivs.forEach((div, index) => {
      if (index > 0) div.remove();
    });

    // Direct Shopify search - no local validation needed since metafields are 100% accurate
    const encodedGeneration = encodeURIComponent(generation);
    const encodedMake = encodeURIComponent(make);
    const encodedModel = encodeURIComponent(model);
    const encodedYear = encodeURIComponent(year);

    let url = `https://apesan.myshopify.com/collections/all?filter.p.m.custom.generation=${encodedGeneration}&filter.p.m.custom.make=${encodedMake}&filter.p.m.custom.model=${encodedModel}&filter.p.m.custom.years=${encodedYear}&sort_by=title-ascending`;

    console.log("Search URL:", url);
    console.log("Search parameters:", { generation, make, model, year });

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((html) => {
        // Create a temporary element to parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Check if there are any product elements on the page
        const productElements = doc.querySelectorAll(
          ".product-grid .grid__item"
        );

        if (productElements.length > 0) {
          // Products found - vehicle is compatible
          console.log(`Found ${productElements.length} matching products`);
          this.showSuccess(year, make, model, parentForm);
        } else {
          // No products found - vehicle is not compatible
          console.log("No matching products found in Shopify");
          this.showNotFound(parentForm);
        }
      })
      .catch((error) => {
        console.error("Search error:", error);
        this.showNotFound(parentForm);
      })
      .finally(() => {
        loadingDiv.remove();
      });
  },

  showSuccess: function (year, make, model, parentForm) {
    const filterList = parentForm.querySelector(".filter-list");

    if (filterList.style.display === "flex") {
      return;
    }

    // Remove any existing messages
    this.removeExistingMessages(parentForm);

    const successDiv = document.createElement("div");
    successDiv.setAttribute("data-success-message", "");
    successDiv.innerHTML = `
      <div style="text-align: center; margin: 20px 0;">
        <p style="color: green; margin-bottom: 10px;">${year} ${make} ${model} aracınız ile uyumlu!</p>
        <button class="return-to-form-btn" 
                style="padding: 10px 20px; background: #000; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Forma Geri Dön
        </button>
      </div>
    `;

    const returnBtn = successDiv.querySelector(".return-to-form-btn");
    returnBtn.addEventListener("click", () => {
      this.showFilterForm(parentForm);
    });

    filterList.parentNode.insertBefore(successDiv, filterList);

    // Enable purchase buttons
    this.enablePurchaseButtons();
  },

  showNotFound: function (parentForm) {
    const filterList = parentForm.querySelector(".filter-list");

    if (filterList.style.display === "flex") {
      return;
    }

    // Remove any existing messages
    this.removeExistingMessages(parentForm);

    const notFoundDiv = document.createElement("div");
    notFoundDiv.setAttribute("data-not-found-message", "");

    notFoundDiv.innerHTML = `
      <div style="text-align: center; margin: 20px 0;">
        <p style="color: red; margin-bottom: 10px;">Uygun değildir.</p>
        <button class="return-to-form-btn" 
                style="padding: 10px 20px; background: #000; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Forma Geri Dön
        </button>
      </div>
    `;

    const returnBtn = notFoundDiv.querySelector(".return-to-form-btn");
    returnBtn.addEventListener("click", () => {
      this.showFilterForm(parentForm);
    });

    filterList.parentNode.insertBefore(notFoundDiv, filterList);
  },

  removeExistingMessages: function (parentForm) {
    const filterList = parentForm.querySelector(".filter-list");
    const existingSuccess = filterList.parentNode.querySelector(
      "[data-success-message]"
    );
    const existingNotFound = filterList.parentNode.querySelector(
      "[data-not-found-message]"
    );

    if (existingSuccess) existingSuccess.remove();
    if (existingNotFound) existingNotFound.remove();
  },

  enablePurchaseButtons: function () {
    const style = document.createElement("style");
    style.id = "vehicle-filter-purchase-style";
    style.textContent = `
      .shopify-payment-button, .product-form__submit {
        pointer-events: auto !important;
        opacity: 1 !important;
      }
    `;

    // Remove existing style if present
    const existingStyle = document.getElementById(
      "vehicle-filter-purchase-style"
    );
    if (existingStyle) existingStyle.remove();

    document.head.appendChild(style);
  },

  disablePurchaseButtons: function () {
    const style = document.createElement("style");
    style.id = "vehicle-filter-purchase-style";
    style.textContent = `
      .shopify-payment-button, .product-form__submit {
        pointer-events: none !important;
        opacity: 0.5 !important;
      }
    `;

    // Remove existing style if present
    const existingStyle = document.getElementById(
      "vehicle-filter-purchase-style"
    );
    if (existingStyle) existingStyle.remove();

    document.head.appendChild(style);
  },

  showFilterForm: function (parentForm) {
    // Remove any existing messages
    this.removeExistingMessages(parentForm);

    // Disable purchase buttons
    this.disablePurchaseButtons();

    // Reset form to default state
    const defaultTexts = {
      tr: {
        year: "Yıl",
        make: "Marka",
        model: "Model",
        generation: "Nesil/Kasa",
      },
      en: {
        year: "Year",
        make: "Make",
        model: "Model",
        generation: "Generation/Body",
      },
    };

    // Detect language from existing text or default to Turkish
    const currentMakeText = parentForm.querySelector(
      ".makeSelectedCustom"
    ).textContent;
    const lang =
      currentMakeText === "Make" || currentMakeText === "Year" ? "en" : "tr";

    parentForm.querySelector(".yearSelectedCustom").textContent =
      defaultTexts[lang].year;
    parentForm.querySelector(".makeSelectedCustom").textContent =
      defaultTexts[lang].make;
    parentForm.querySelector(".modelSelectedCustom").textContent =
      defaultTexts[lang].model;
    parentForm.querySelector(".generationSelectedCustom").textContent =
      defaultTexts[lang].generation;

    parentForm.querySelector(".filter-list").style.display = "flex";
    parentForm.querySelector(".vehicle-search-btn").style.display = "block";

    parentForm.querySelector(".model-parent").classList.add("disabled");
    parentForm.querySelector(".year-parent").classList.add("disabled");
    parentForm.querySelector(".generation-parent").classList.add("disabled");
  },

  resetFilter: function (parentForm) {
    this.showFilterForm(parentForm);
  },

  getYears: function () {
    return [
      1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003,
      2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
      2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025,
    ];
  },

  getVehicles: function () {
    return {
      Audi: {
        A1: { kasaTipi: "II" },
        A3: { kasaTipi: "II" },
      },
      Tesla: {
        "Model Y": { kasaTipi: "Frunk" },
      },
      VW: {
        Golf: ["MK 7", "MK 8"],
      },
    };
  },
};

window.initVehicleFilter = initVehicleFilter;

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    window.initVehicleFilter.init();
  });
} else {
  window.initVehicleFilter.init();
}
